import { Component, OnDestroy } from '@angular/core';
import { Platform, NavController, AlertController, ToastController, ViewController, ModalController, LoadingController } from 'ionic-angular';
import { Storage } from '@ionic/storage';
import { TranslateService } from '@ngx-translate/core';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { provider } from '../../../providers/provider';
import { HttpClient } from '@angular/common/http';
import { Subject } from 'rxjs';
import { ModalPrivacyPage } from '../modalPrivacy/modalPrivacy';
import { CustomizerProvider } from '../../../providers/customizer/customizer';
import { InAppBrowser, InAppBrowserOptions } from '@ionic-native/in-app-browser';

import { MenuPage } from '../../menu/menu';
import { ModalVerificaUtente } from '../modalVerificaUtente/modalVerificaUtente';

declare let window: any;

@Component({
  selector: 'page-customerRegistration',
  templateUrl: 'customerRegistration.html'
})
export class CustomerRegistrationPage implements OnDestroy {
  private form: FormGroup;
  private pendingCall = false;
  url: string;
  private _onDestroy = new Subject();
  emailValidation = false;
  privacy1: string;
  privacy2: string;
  privacy3: string;
  data: any;
  options: InAppBrowserOptions = {
    hardwareback: 'yes',
    toolbar: 'yes'
  };

  constructor(public navCtrl: NavController,
    public translateService: TranslateService,
    public storage: Storage,
    public platform: Platform,
    public toastCtrl: ToastController,
    public alertCtrl: AlertController,
    public provider: provider,
    public viewCtrl: ViewController,
    private formBuilder: FormBuilder,
    public modalCtrl: ModalController,
    public http: HttpClient,
    public customizer: CustomizerProvider,
    public loadingCtrl: LoadingController,
    private iab: InAppBrowser) {

    this.url = provider.getUrl();
    this.data = provider.getMenu();

    this.form = this.formBuilder.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      telephone: ['', Validators.required],
      email: ['', Validators.compose([Validators.required, Validators.email])],
      password: ['', Validators.compose([Validators.required, Validators.minLength(5)])],
      confirmPassword: ['', Validators.compose([Validators.required])],
      general: [false, Validators.compose([Validators.required,Validators.pattern('true')])],
      marketing: [false],
      profiling: [false],
    }, { validator: CustomerRegistrationPage.passwordsMatch });

  }

  askTrackingPermission() {
    if (this.platform.is('cordova') && this.platform.is('ios')) {

      if (window.cordova) {
        console.log('trying to request permission ');
        window.cordova.exec(win, fail, 'idfa', "requestPermission", []);
      }
    }

    function win(res) {
      console.log('success ' + JSON.stringify(res));
    }
    function fail(res) {
      console.log('fail ' + JSON.stringify(res));
    }
  }

  readTrackingPermission() {

    if (this.platform.is('cordova') && this.platform.is('ios')) {

      if (window.cordova) {
        window.cordova.exec(win, fail, 'idfa', "getInfo", []);
      }
    }

    function win(res) {
      console.log('success  ' + JSON.stringify(res));
    }
    function fail(res) {
      console.log('fail ' + JSON.stringify(res));
    }
  }

  ngOnDestroy() {
    this._onDestroy.next();
  }

  static passwordsMatch(cg: FormGroup): { [err: string]: any } {
    let pwd1 = cg.get('password');
    let pwd2 = cg.get('confirmPassword');
    let rv: { [error: string]: any } = {};
    if ((pwd1.touched || pwd2.touched) && pwd1.value !== pwd2.value) {
      rv['passwordMismatch'] = true;
    }
    return rv;
  }

  logForm(){
    //console.log(this.form)
  }

  registerWithCall() {
    const loading = this.loadingCtrl.create({
      content: '<ion-spinner name="circles"></ion-spinner>'
    });

    loading.present().then(() => {
      let form = this.form.value;
      form.addresses = [];
      form.privacy = { general: form.general, marketing: form.marketing, profiling: form.profiling }
      delete form.general;
      delete form.marketing;
      delete form.profiling;
      this.provider.verifyEmail(form.email).takeUntil(this._onDestroy).subscribe((response) => {
        let resp = JSON.parse((<any>response)._body);
        if (!resp.success) {
          this.emailValidation = true;
          loading.dismiss();
          this.pendingCall = false;
          this.handleError(resp.info);
          return;
        } else {
          // togli l'errore
          this.emailValidation = false;
          this.pendingCall = true;    
          this.provider.phoneCall(form).takeUntil(this._onDestroy).subscribe(() => {
            this.verifica('call');
            this.pendingCall = false;
            loading.dismiss();
          }, err => {
            // show translated error message
            loading.dismiss();
            this.handleError(err._body);
            this.pendingCall = false;    
          });
        }
      }, (error) => {
        loading.dismiss();
        this.pendingCall = false;
        this.handleError("Errore campo Email - " + JSON.parse(error._body).info);
      })
    });
  }

  registerWithSMS() {
    const loading = this.loadingCtrl.create({
      content: '<ion-spinner name="circles"></ion-spinner>'
    });

    loading.present().then(() => {
      let form = this.form.value;
      form.addresses = [];
      form.privacy = { general: form.general, marketing: form.marketing, profiling: form.profiling }
      delete form.general;
      delete form.marketing;
      delete form.profiling;
      this.provider.verifyEmail(form.email).takeUntil(this._onDestroy).subscribe((response) => {
        let resp = JSON.parse((<any>response)._body);
        if (!resp.success) {
          this.emailValidation = true;
          loading.dismiss();
          this.pendingCall = false;
          this.handleError(resp.info);
          return;
        } else {
          // togli l'errore
          this.emailValidation = false;
        }
      }, (error) => {
        loading.dismiss();
        this.pendingCall = false;
        this.handleError("Errore campo Email - " + JSON.parse(error._body).info);
        this.provider.phoneSMS(form).takeUntil(this._onDestroy).subscribe(() => {
          this.verifica('sms');
        this.pendingCall = false;
         loading.dismiss();
       }, err => {
          // show translated error message
          loading.dismiss();
          this.handleError(err._body);
          this.pendingCall = false;
        });
      })
    });
  }

  verifica(method) {
    let verifica = this.modalCtrl.create(ModalVerificaUtente, { method: method });
    verifica.onDidDismiss(data => {
      this.provider.register(data)
          .map(res => res.json())
          .takeUntil(this._onDestroy)
          .subscribe(data => {
            this.storage.set('customer', JSON.stringify(data));
            let toast = this.toastCtrl.create({
              message: 'La registrazione è andata a buon fine',
              duration: 3000,
              position: 'middle'
            });
            this.provider.setFirstOrder(true);
            toast.present();
            this.navCtrl.push(MenuPage);
          },
            err => {
              let toast = this.toastCtrl.create({
                message: 'Il codice inserito è errato! Riprova',
                duration: 3000,
                position: 'middle'
              });
              toast.present();
              // show translated error message
              this.handleError(err._body);
            });
    });
    verifica.present();
  }

  // Handle error shows a translated error messages
  // if message is an error-coded one, or a generic message
  handleError(message: string) {
    var translatedMessage : string;
    if (message == "It's not a valid number")
      message = 'not_valid_number';

    this.translateService
      .get(message)
      .takeUntil(this._onDestroy)
      .subscribe(value => { translatedMessage = value });                 
    let toast = this.toastCtrl.create({
      message: translatedMessage,
      duration: 3000,
      position: 'middle'
    });
    toast.present();
  }

  privacy() {
    if(this.data.settings.privacyPageUrl && this.data.settings.privacyPageUrl !== '') {
      const browser = this.iab.create(this.data.settings.privacyPageUrl, '_blank', this.options);
    } else {
      const modal = this.modalCtrl.create(ModalPrivacyPage);
      modal.present();
    }
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }

}



// WEBPACK FOOTER //
// ./src/pages/account/customerRegistration/customerRegistration.ts